var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInventoryControl(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_754",
    "data-name": "Group 754",
    transform: "translate(-288 -2075)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_753",
    "data-name": "Group 753"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_494",
    "data-name": "Rectangle 494",
    width: 40,
    height: 40,
    transform: "translate(288 2075)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("path", {
    id: "production",
    d: "M21.941,11.784V0H6.79V11.784H0V28.731H28.731V11.784Zm-1.683,1.683h1.683v3.367H20.258ZM13.524,1.683h1.683V5.05H13.524Zm-5.05,0H11.84v5.05h5.05V1.683h3.367v10.1H8.473ZM6.79,13.468H8.473v3.367H6.79Zm-5.106,0H5.106v5.05h5.05v-5.05h3.367v10.1H1.683Zm25.364,13.58H1.683v-1.8H27.047Zm-11.84-3.479v-10.1h3.367v5.05h5.05v-5.05h3.423v10.1Z",
    transform: "translate(293.635 2080.635)",
    fill: "#4A4A4A"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInventoryControl);
export default __webpack_public_path__ + "static/media/inventory-control.d3bae11a941255452fec32561f04b0af.svg";
export { ForwardRef as ReactComponent };